<template>
    <div class="container">
        <div class="header">
            <h1 class="text">
            </h1>
            <img class="logo" src="@/assets/bfp-logo.svg" />
        </div>

        <div v-if="loading" class="loading">
            <div class="lds-dual-ring"></div>
        </div>
        <div v-else>            
            <div v-if="showReservation && reservation.length >= 1" class="reservation">
                <div v-for="item in reservation" :key="item.table" :id="item.table">
                    <h1> Reserviert </h1>
                    <div class="student"><h3>{{item.Student}}</h3></div>
                    <div class="timeLeft"><h3>{{timeLeft(item.StartTime)}}</h3></div>
                </div>
            </div>
            <div v-else>
                <h1> Reservierung </h1>
                <input type="text" class="student" v-model="reservationData.student" name="student" @keyup.enter="reserveTable()" placeholder="Bitte gib deinen Namen ein">
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'Reservation',
    data() {
        return {
            reservationData: {
                table: this.$route.params.table ? this.$route.params.table : "",
                student: this.student,
            }
        }
    },
    created() {
        this.moment = moment;
    },
    mounted() {
        // check at mounted if link has query
        console.log("calling Reservation:mounted()", this.$route.params)
        if (this.$route.params.table) {
            //console.log("calling searchForm:mounted()", this.$route.params)
            this.isTableReserved();  
        } 
    },
    computed: {
        reservation: function() {
            return this.$store.state.reservation;
        },
        loading: function() {
            return this.$store.state.loading;
        },
        showReservation: function() {
            return this.$store.getters.showReservation;
        },
    },
    methods: {
        reserveTable() {
            console.log("DATA RESERVATION", this.reservationData, "TABLE?", this.reservationData.table != "", "TABLE IS NUMBER?", !isNaN(Number(this.reservationData.table)), "STUDENT?", this.reservationData.student != "")
            if (this.reservationData.table != "" && !isNaN(Number(this.reservationData.table)) && this.reservationData.student != "") {
                this.$store.dispatch('reserveTable', this.reservationData);
            }
        },
        isTableReserved() {
            if (this.reservationData.table != "") {
                this.$store.dispatch('isTableReserved', this.reservationData);
            }
        },
        timeLeft(startTime) {
            let addTwoHours = moment(startTime).add(3, 'hours');
            console.log("CURRENT TIME", moment().format("HH:mm:ss"), "Add 2h", addTwoHours.format("HH:mm:ss"), "IS RESERVATION OVER?", moment().isAfter(addTwoHours))
            if (moment().isAfter(addTwoHours)) {
                this.$store.dispatch('removeReservation', this.reservationData);
                this.$router.push({ name: 'table', params: {table: this.reservationData.table } })
            }
            return parseInt(moment.duration(addTwoHours.diff(moment())).asMinutes()) <= 1 ? parseInt(moment.duration(addTwoHours.diff(moment())).asSeconds()) +  " Sekunden" : parseInt(moment.duration(addTwoHours.diff(moment())).asMinutes()) +  " Minuten"
        }
    },
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  .logo {
    width: 280px;
  }
  .text {
    font-weight: 200;
  }
}  

@media (max-width: 900px) {
  .header .logo {
    display: none;
  }
}

.container {
  margin: 10px;
  padding: 10px;
  overflow: auto;
  min-height: 90vh;
}

input {
    border-style: none; 
    background: transparent; 
    outline: none; 
    height: 50px;
    padding: 0 55px 0 10px;
    color: #222;
    font-size: 15px;
    line-height: 1.2;
    border: $border;
    text-align: left;
    background-color: $bgColor;
    width: 100%;
    margin-top: 15px;
}

.reservation {
    margin-top: 2em;
    text-align: center;
}
/* LOADING SPINNER */
.loading {
    display: flex;
    justify-content: center;
    height: 300px;
    align-items: center;
    margin-left: -15px;
}

.lds-dual-ring {
  display: inline-block;
  width: 30px;
  height: 30px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 34px;
  height: 34px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #ccc;
  border-color: #ccc transparent #ccc transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>